var exports = {
  "Gf": "FriendsListSection.module__sectionTitle___V2ZjTF",
  "f5": "FriendsListSection.module__sectionContent___V2ZjTF",
  "v2": "FriendsListSection.module__sectionContentWithMargin___V2ZjTF",
};

module.exports = exports;
